import { useSearchParams } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import ReactQuill from 'react-quill';
import { useNavigate } from "react-router-dom";


import { useParams } from "react-router-dom";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
  InputAdornment,
  IconButton,
  Divider,
  Chip,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import InfoIcon from "@mui/icons-material/Info";




import 'react-quill/dist/quill.snow.css';
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  AppBar,
  Toolbar,
  Container,
  Modal,
  Tooltip,
} from '@mui/material';
import LoadingBar from 'react-top-loading-bar';

// Info modal field descriptions
const infoSections = [
  {
    title: 'Page Overview',
    color: '#0B1F3D',
    description:
      'The Edit Announcement page allows authorized users to update an existing announcement. The form is pre-filled with the existing data fetched by announcement ID and branch. Once updated, the changes are saved to the server and the user is navigated back.',
  },
  {
    title: 'Form Fields',
    color: '#1565C0',
    fields: [
      {
        label: 'Branch',
        desc: 'Displays the branch associated with this announcement. This field is read-only (disabled) and is set automatically from the URL query parameter or session storage. Master users can see the branch name but cannot change it here.',
      },
      {
        label: 'Select User(s)',
        desc: 'Multi-select dropdown to choose one or more user groups (e.g., Students, Teachers, Parents) for the announcement. Pre-filled from the existing announcement data based on matching user group names.',
      },
      {
        label: 'Select Class(es)',
        desc: 'Multi-select dropdown to choose one or more classes. Pre-filled from the existing announcement\'s class names by matching against the fetched class options.',
      },
      {
        label: 'Select Section',
        desc: 'Single-select dropdown to choose a section. Disabled until at least one class is selected. Pre-filled by parsing the section from the existing announcement\'s className (e.g., "LKG-A1" → section "A1").',
      },
      {
        label: 'Title',
        desc: 'A short, descriptive heading for the announcement. Pre-filled with the existing title and editable as a required text field.',
      },
      {
        label: 'Message',
        desc: 'The full body of the announcement in rich text (WYSIWYG) format. Pre-filled with the existing message content and editable using the Quill editor.',
      },
    ],
  },
  {
    title: 'Form Actions',
    color: '#2E7D32',
    fields: [
      {
        label: 'Save Announcement',
        desc: 'Submits the updated announcement to the server using a POST request with the announcement ID and branch ID. Disabled until all required fields are filled. Shows a success or error modal after submission.',
      },
      {
        label: 'Cancel',
        desc: 'Navigates back to the previous page (announcement view) without saving any changes.',
      },
    ],
  },
  {
    title: 'Validations & Behaviour',
    color: '#E65100',
    fields: [
      {
        label: 'Pre-fill on Load',
        desc: 'On load, the component fetches the announcement by ID and branch, then auto-populates title, message, users, classes, and section based on the stored data.',
      },
      {
        label: 'Required Fields',
        desc: 'Branch, User(s), Class(es), Section, Title, and Message must all be filled before the Save button is enabled. An inline error message is shown if validation fails.',
      },
      {
        label: 'Section Dependency',
        desc: 'The Section dropdown is disabled until at least one class is selected. Sections are re-fetched whenever the selected class changes.',
      },
      {
        label: 'Branch Context',
        desc: 'All API calls include the active Branch_Id (from URL query or session storage) as a query parameter to scope data correctly per branch.',
      },
      {
        label: 'Loading Bar',
        desc: 'A top loading bar is shown during all API calls and resets to 0 on completion or error.',
      },
    ],
  },
];

const EditAnnouncement = () => {
    const { id } = useParams(); // Extract announcementId from URL
const [announcementData, setAnnouncementData] = useState(null);
const [searchParams] = useSearchParams();
const branchIdFromQuery = searchParams.get("Branch_Id");
const navigate = useNavigate();
const [isLoading, setIsLoading] = useState(true);


const [isMaster, setIsMaster] = useState(false);
const [branches, setBranches] = useState([]);
const [selectedBranchId, setSelectedBranchId] = useState(null);




  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [selectedSection, setSelectedSection] = useState(null);
  const [message, setMessage] = useState('');
  const [title, setTitle] = useState('');
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('success');
  const [error, setError] = useState('');
  const [classOptions, setClassOptions] = useState([]);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [showInfoModal, setShowInfoModal] = useState(false); // State for Info Modal



  // Fetch user options
  useEffect(() => {
    const fetchUserOptions = async () => {
      
      try {
         const branchId =
        selectedBranchId || sessionStorage.getItem("branchId");


      if (!branchId) return; // ⛔ wait until branch available



        setLoadingBarProgress(30);
       const response = await fetch(`https://wsms.aidigitalsec.com/api/Anouncement/GetUserGroup?Branch_Id=${branchId}`, {
       
  
       method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: sessionStorage.getItem('token'),
          },
          body: JSON.stringify({
            teacherId: sessionStorage.getItem('employeeId'),
          }),
        });
        const data = await response.json();
        const options = data.list.map((user) => ({
          value: user.userGroupId,
          label: user.userGroupname,
        }));
        setUserOptions(options);
        setLoadingBarProgress(100);
      } catch (error) {
        console.error('Error fetching user options:', error);
        setLoadingBarProgress(0);
      }
    };


    fetchUserOptions();
  }, []);


  // Fetch classes using the new API
 useEffect(() => {
  const fetchClassOptions = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const branchId =
        selectedBranchId || sessionStorage.getItem("branchId");


      if (!branchId) return; // ⛔ wait until branch available


      setLoadingBarProgress(30);


      const response = await fetch(
        `${apiUrl}/CreateClass/GetClassName?Branch_Id=${branchId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({}),
        }
      );


      const data = await response.json();


      const options = data.map((cls) => ({
        value: cls.classId,
        label: cls.className,
      }));


      setClassOptions(options);
      setLoadingBarProgress(100);


    } catch (error) {
      console.error("Error fetching class options:", error);
      setLoadingBarProgress(0);
    }
  };


  fetchClassOptions();


}, [selectedBranchId]);  // ✅ reload when branch changes


useEffect(() => {
  const fetchAnnouncementById = async () => {
    try {
      setIsLoading(true);


      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const branchId =
        selectedBranchId || sessionStorage.getItem("branchId");


     if (!id || !branchId) {
  setIsLoading(false);
  return;
}




      setLoadingBarProgress(30);


     const response = await fetch(
  `${apiUrl}/Anouncement/All_Anouncement_Admin?Branch_Id=${branchId}`,
  {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify({
      noticeBoardId: id,
      branchId: branchId,
    }),
  }
);




      if (!response.ok) {
        throw new Error("Failed to fetch announcement");
      }


      
const result = await response.json();


const announcementList = result?.list || [];


const matchedAnnouncement = announcementList.find(
  (item) => String(item.noticeBoardId) === String(id)
);


if (!matchedAnnouncement) {
  setIsLoading(false);
  return;
}


setAnnouncementData(matchedAnnouncement);
setTitle(matchedAnnouncement.title || "");
setMessage(matchedAnnouncement.message || "");










      // ✅ Prefill title & message
     


      setLoadingBarProgress(100);
    } catch (error) {
      console.error("Error fetching announcement:", error);
      setLoadingBarProgress(0);
    } finally {
      setIsLoading(false);
    }
  };


const branchId =
  selectedBranchId || sessionStorage.getItem("branchId");


if (branchId) {
    fetchAnnouncementById();
}


}, [id, selectedBranchId]);






useEffect(() => {
  const fetchSectionOptions = async () => {
    if (!selectedClasses.length) {
      setSectionOptions([]);
      return;
    }


    const classId = selectedClasses[selectedClasses.length - 1].value;


    try {
      setLoadingBarProgress(30);


      const response = await fetch(
        "https://wsms.aidigitalsec.com/api/Exam/ddlSection_clsId",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("token"),
          },
          body: JSON.stringify({ classId }),
        }
      );


      const data = await response.json();


      const options = data.map((section) => ({
        value: section.sectionId,
        label: section.sectionName,
      }));


      setSectionOptions(options);


    // ✅ PREFILL SECTION (robust matching)
// ✅ PREFILL SECTION USING className
if (announcementData?.className && options.length) {
  const firstClass = announcementData.className
    .toString()
    .split(",")[0]
    .trim(); // e.g. "LKG-A1"


  const sectionPart = firstClass.split("-")[1]; // extract A1


  if (sectionPart) {
    const match = options.find(
      (s) =>
        s.label.toLowerCase().trim() ===
        sectionPart.toLowerCase().trim()
    );


    if (match) {
      setSelectedSection(match);
    }
  }
}




      setLoadingBarProgress(100);
    } catch (error) {
      console.error("Error fetching section options:", error);
      setLoadingBarProgress(0);
    }
  };


  fetchSectionOptions();
}, [selectedClasses, announcementData]);




const handleSave = async () => {
  if (
    !selectedBranchId ||
    selectedUsers.length === 0 ||
    selectedClasses.length === 0 ||
    !selectedSection ||
    title.trim() === "" ||
    message.trim() === ""
  ) {
    setError("Please fill in all required fields.");
    return;
  }


  const payload = {
  noticeBoardId: id,
  branchId: selectedBranchId,
  userGroupId: selectedUsers.map(u => u.value),
  classId: selectedClasses.map(c => c.value),
  sectionId: selectedSection.value,
  title: title.trim(),
  message: message.trim(),
};




  try {
    setLoadingBarProgress(30);


    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");


    const response = await fetch(
  `${apiUrl}/Anouncement/Id?Id=${id}&Branch_Id=${selectedBranchId}`,
  {
    method: "POST", // ✅ Use POST instead of PUT
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify(payload),
  }
);




    if (!response.ok) {
      throw new Error("Update failed");
    }


    setModalType("success");
    setModalMessage("Announcement Updated Successfully!");
    setModalOpen(true);
    setLoadingBarProgress(100);


  } catch (error) {
    console.error(error);
    setModalType("error");
    setModalMessage("Failed to update announcement");
    setModalOpen(true);
    setLoadingBarProgress(0);
  }
};




const handleCancel = () => {
  navigate(-1); // back to View page
};


const fetchBranches = async () => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");


    const response = await fetch(`${apiUrl}/Branch/GetBranch`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({}),
    });


    if (response.ok) {
      const data = await response.json();
      setBranches(data);
    }
  } catch (error) {
    console.error("Error fetching branches:", error);
  }
};
useEffect(() => {
  const isMasterUser = sessionStorage.getItem("is_Master") === "true";
  setIsMaster(isMasterUser);


  // Set the branchId from query parameter or sessionStorage
  const branchId = branchIdFromQuery || sessionStorage.getItem("branchId");
  setSelectedBranchId(branchId);


  if (isMasterUser) {
    fetchBranches();
  }
}, [branchIdFromQuery]);




useEffect(() => {
  if (!announcementData) return;
  if (!userOptions.length || !classOptions.length) return;


  // Prefill users
 if (announcementData?.createdFor) {
  const userNames = announcementData.createdFor
    .toString()
    .split(",")
    .map((name) => name.trim().toLowerCase());

  const matchedUsers = userOptions.filter((u) =>
    userNames.includes(u.label.toLowerCase())
  );

  setSelectedUsers(matchedUsers);
}



  // Prefill classes
  if (announcementData.className) {
    const classNames = announcementData.className
      .split(",")
      .map((name) => name.trim());


    const matchedClasses = classOptions.filter((c) =>
      classNames.some((name) =>
        name.includes(c.label)
      )
    );


    setSelectedClasses(matchedClasses);
  }
}, [announcementData, userOptions, classOptions]);


useEffect(() => {
  console.log("ANNOUNCEMENT DATA:", announcementData);
}, [announcementData]);


if (isLoading) {
  return (
    <Container>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <Typography>Loading announcement details...</Typography>
      </Box>
    </Container>
  );
}




  return (
    <Container sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <LoadingBar color="#0B1F3D" progress={loadingBarProgress} onLoaderFinished={() => setLoadingBarProgress(0)} />
     <AppBar position="static" sx={{ backgroundColor: "#0B1F3D" }}>
  <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>


    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
  <Typography variant="h4" component="div" sx={{ fontWeight: 'bold' }}>
    Edit Announcement
  </Typography>

  <Tooltip title="View page information & field details" arrow>
    <IconButton
      onClick={() => setShowInfoModal(true)}
      sx={{
        color: '#fff',
        backgroundColor: 'rgba(255,255,255,0.15)',
        border: '1px solid rgba(255,255,255,0.4)',
        borderRadius: '50%',
        width: 34,
        height: 34,
        '&:hover': {
          backgroundColor: 'rgba(255,255,255,0.28)',
        },
      }}
    >
      <InfoIcon fontSize="small" />
    </IconButton>
  </Tooltip>
</Box>


    {/* Right side: Branch Dropdown + Info Button */}
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <FormControl size="small" sx={{ width: 220 }}>
        <InputLabel sx={{ color: "white" }}>Branch</InputLabel>
        <MuiSelect
          value={selectedBranchId || ""}
          label="Branch"
          disabled
          startAdornment={
            <InputAdornment position="start">
              <LocationOnIcon sx={{ fontSize: 16 }} />
            </InputAdornment>
          }
          sx={{
            color: "white",
            backgroundColor: "rgba(255,255,255,0.1)",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(255,255,255,0.3)",
            },
            "& .MuiSvgIcon-root": { color: "white" },
            "& .MuiSelect-select.Mui-disabled": {
              color: "white !important",
              WebkitTextFillColor: "white !important",
            },
          }}
        >
          {branches.map((branch) => (
            <MenuItem key={branch.branchId} value={branch.branchId}>
              {branch.branchName}
            </MenuItem>
          ))}
        </MuiSelect>
      </FormControl>

     
    </Box>

  </Toolbar>
</AppBar>


      <Paper elevation={3} style={{ padding: 24, width: '100%', margin: 'auto', marginTop: 3 }}>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Select User(s) *
          </Typography>
          <Select
            isMulti
            options={userOptions}
            value={selectedUsers}
            onChange={setSelectedUsers}
            placeholder="Select user(s)"
            styles={{
              control: (base) => ({
                ...base,
                minHeight: 56,
                borderRadius: 8,
                borderColor: '#ccc',
              }),
            }}
          />
        </Box>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Select Class(es) *
          </Typography>
          <Select
            isMulti
            options={classOptions}
            value={selectedClasses}
            onChange={setSelectedClasses}
            placeholder="Select class(es)"
            styles={{
              control: (base) => ({
                ...base,
                minHeight: 56,
                borderRadius: 8,
                borderColor: '#ccc',
              }),
            }}
          />
        </Box>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Select Section *
          </Typography>
          <Select
            options={sectionOptions}
            value={selectedSection}
            onChange={setSelectedSection}
            placeholder="Select section"
            isDisabled={selectedClasses.length === 0}
            styles={{
              control: (base) => ({
                ...base,
                minHeight: 56,
                borderRadius: 8,
                borderColor: '#ccc',
              }),
            }}
          />
        </Box>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Title *
          </Typography>
          <TextField
            fullWidth
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter announcement title"
            variant="outlined"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
        </Box>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Message *
          </Typography>
          <Box
            sx={{
              '& .ql-container': { minHeight: 200, borderRadius: 2 },
              '& .ql-toolbar': { borderRadius: '8px 8px 0 0' },
              '& .ql-editor': { minHeight: 180 },
            }}
          >
            <ReactQuill
              value={message}
              onChange={setMessage}
              placeholder="Enter announcement message..."
              theme="snow"
            />
          </Box>
        </Box>
        {error && (
          <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
            {error}
          </Typography>
        )}
        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', gap: 3 }}>
          <Tooltip
            title={
              !selectedUsers.length
                ? "Select User(s)"
                : !selectedClasses.length
                ? "Select Class(es)"
                : !selectedSection
                ? "Select Section"
                : !title.trim()
                ? "Enter Title"
                : !message.trim()
                ? "Enter Message"
                : ""
            }
            arrow
          >
            <span>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSave}
                sx={{ minWidth: 220 }}
              disabled={
  !selectedBranchId ||
  !selectedUsers.length ||
  !selectedClasses.length ||
  !selectedSection ||
  !title.trim() ||
  !message.trim()
}


              >
                Save Announcement
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
            sx={{ minWidth: 220 }}
          >
            Cancel
          </Button>
        </Box>
      </Paper>

      {/* Success/Error Modal */}
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="response-modal-title"
        aria-describedby="response-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              backgroundColor: modalType === 'success' ? '#0B1F40' : '#d32f2f',
              padding: '12px 16px',
            }}
          >
            <Typography id="response-modal-title" variant="h6" sx={{ color: '#fff' }}>
              {modalType === 'success' ? 'Success ✅' : 'Error ❌'}
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="response-modal-description" sx={{ mb: 2 }}>
              {modalMessage}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {setModalOpen(false); navigate(-1)}}
                variant="contained"
                color={modalType === 'success' ? 'primary' : 'error'}
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* ── Info Modal ── */}
      <Modal
        open={showInfoModal}
        onClose={() => setShowInfoModal(false)}
        aria-labelledby="info-modal-title"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '95vw', sm: 620 },
            maxHeight: '85vh',
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* Info Modal Header */}
          <Box
            sx={{
              backgroundColor: '#0B1F3D',
              padding: '14px 20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <InfoIcon sx={{ color: '#90CAF9', fontSize: 22 }} />
              <Typography id="info-modal-title" variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
                Edit Announcement — Page Information
              </Typography>
            </Box>
           
          </Box>

          {/* Info Modal Scrollable Body */}
          <Box sx={{ overflowY: 'auto', padding: '20px', flex: 1 }}>
            {infoSections.map((section, sIdx) => (
              <Box key={sIdx} sx={{ mb: 3 }}>
                {/* Section Title */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                  <Box
                    sx={{
                      width: 4,
                      height: 22,
                      borderRadius: 1,
                      backgroundColor: section.color,
                    }}
                  />
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: section.color }}>
                    {section.title}
                  </Typography>
                </Box>

                {/* Overview text (no fields) */}
                {section.description && (
                  <Typography variant="body2" sx={{ color: '#555', pl: 1.5 }}>
                    {section.description}
                  </Typography>
                )}

                {/* Field rows */}
                {section.fields && (
                  <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, overflow: 'hidden' }}>
                    {section.fields.map((field, fIdx) => (
                      <Box key={fIdx}>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: 2,
                            px: 2,
                            py: 1.2,
                            backgroundColor: fIdx % 2 === 0 ? '#fafafa' : '#fff',
                          }}
                        >
                          <Chip
                            label={field.label}
                            size="small"
                            sx={{
                              backgroundColor: section.color,
                              color: '#fff',
                              fontWeight: 'bold',
                              fontSize: '0.72rem',
                              minWidth: 120,
                              borderRadius: '4px',
                              flexShrink: 0,
                            }}
                          />
                          <Typography variant="body2" sx={{ color: '#444', lineHeight: 1.6 }}>
                            {field.desc}
                          </Typography>
                        </Box>
                        {fIdx < section.fields.length - 1 && <Divider />}
                      </Box>
                    ))}
                  </Box>
                )}

                {sIdx < infoSections.length - 1 && <Divider sx={{ mt: 2 }} />}
              </Box>
            ))}
          </Box>

          {/* Info Modal Footer */}
          <Box
            sx={{
              borderTop: '1px solid #e0e0e0',
              px: 2.5,
              py: 1.5,
              display: 'flex',
              justifyContent: 'flex-end',
              backgroundColor: '#f9f9f9',
            }}
          >
            <Button
              variant="contained"
              onClick={() => setShowInfoModal(false)}
              sx={{ backgroundColor: '#0B1F3D', '&:hover': { backgroundColor: '#163060' } }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>

    </Container>
  );
};


export default EditAnnouncement;